import React, { useCallback } from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Icon, ReduxControls } from "rhombus-react";
import {
	PINTEREST_COMMON_CONSTRAINTS,
	PINTEREST_DISCLOSURE_TYPES
} from "social/validators/pinterest";
import { noop } from "utils/common";
import { normalizeOptionToString } from "social/utils";

import "./PinterestDisclosure.css";

const DISCLOSURE_URL_PLACEHOLDER = "https://";
const disclosureIdOptions = Object.entries(PINTEREST_DISCLOSURE_TYPES).map(([key, value]) => ({
	label: value,
	value: key,
}));
const mapDisclosureValueToOption = (value) => {
	const label = PINTEREST_DISCLOSURE_TYPES[value];
	return label ? {
		value,
		label,
	} : null;
};

export default function PinterestDisclosure(props){
	const {
		input: { value, onChange } = {},
		disabled = false,
		className = "",
		showPristineErrors,
	} = props;

	const onToggleChange = useCallback((e) => {
		e.stopPropagation();
		if(!disabled){
			onChange(!value);
		}
	}, [disabled, onChange, value]);


	return (
		<div
			className={classNames("pinterest-disclosure-wrapper", "e-form__control-wrapper", {
				[className]: !!className,
			})}
		>
			<div className="full-width e-form__control-header">
				<div
					className={classNames({
						"pinterest-disclosure-field": true,
						"is-checked": !!value,
					})}
					onClick={onToggleChange}
					disabled={disabled}
				>
					<div className="pinterest-disclosure-slider"> </div>
				</div>
				<div className="e-form__control-label">
					Disclosure&nbsp;
					<Icon name="help-tip fas fa-info-circle" data-tip="Adding disclosures to your ads could help you avoid legal risks." />
				</div>
			</div>
			{!!value && (
				<div className="full-width">
					<div className="pinterest-disclosure-body">
						<Field
							name="disclosureType"
							key="disclosureType"
							label="Disclosure Type"
							required
							component={ReduxControls.Select}
							options={disclosureIdOptions}
							isClearable={false}
							disabled={disabled}
							showPristineErrors={!!showPristineErrors}
							onMenuScrollToBottom={noop}
							normalize={normalizeOptionToString}
							format={mapDisclosureValueToOption}
						/>
						<Field
							name="disclosureUrl"
							key="disclosureUrl"
							label="Disclosure URL"
							className="pinterest-disclosure-textarea"
							component={ReduxControls.Input}
							placeholder={DISCLOSURE_URL_PLACEHOLDER}
							disabled={disabled}
							charMax={PINTEREST_COMMON_CONSTRAINTS.MAX_DISCLOSURE_URL_LENGTH}
							showCharCount
							required
							showPristineErrors={!!showPristineErrors}
						/>
					</div>
				</div>
			)}
		</div>
	);
}

PinterestDisclosure.displayName = "PinterestDisclosure";

PinterestDisclosure.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.any,
		onChange: PropTypes.func,
	}),
	disabled: PropTypes.bool,
	className: PropTypes.string,
	showPristineErrors: PropTypes.bool,
};
